/*
 * @Author: Teemo Ding
 * @Date: 2021-11-02 16:52:24
 * @LastEditTime: 2021-11-03 17:38:27
 * @LastEditors: Luke Z
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Order/Components/SkuItems/index.tsx
 */
import React from 'react';
import css from './css.module.less';

const SkuItems = ({ data }) => {
  return data.map((item, index) => (
    <div className={css.skuItem} key={index}>
      {item.map((list, index) => (
        <span key={index}>{list}</span>
      ))}
    </div>
  ));
};

export default SkuItems;
